import { LapChart } from './LapChart';
import { useResizeObserver } from './useResizeObserver';

export const ChartCard = ({
  data,
  status = 'ready',
  onLapClick,
  title,
  subtitle,
  height = 480,
  action = null,
}) => {
  const { ref, width, height: observedHeight } = useResizeObserver();
  const chartHeight = observedHeight || height;

  return (
    <section className="rounded-2xl border border-f1-border bg-f1-surface overflow-hidden">
      {(title || action) && (
        <header className="flex items-start justify-between gap-4 px-5 pt-5 pb-3">
          <div>
            {title && (
              <h2 className="text-base font-semibold tracking-tight text-f1-text">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-xs text-f1-muted mt-0.5">{subtitle}</p>
            )}
          </div>
          {action}
        </header>
      )}
      <div
        ref={ref}
        className="relative w-full"
        style={{ height: `${height}px` }}
      >
        {status === 'error' ? (
          <div className="absolute inset-0 grid place-items-center text-f1-muted text-sm">
            Couldn't load this race.
          </div>
        ) : data && width > 0 ? (
          <LapChart data={data} width={width} height={chartHeight} onLapClick={onLapClick} />
        ) : (
          <div className="absolute inset-0 grid place-items-center text-f1-muted text-sm">
            {data ? 'Sizing chart…' : 'Loading…'}
          </div>
        )}
      </div>
    </section>
  );
};
